export const MFG_GRAPHQL_URL = 'https://developer.api.autodesk.com/mfg/graphql';
export const FUSION_LOGGING_URL = '/integrations/fusion/log_interaction';

export const MFG_ITEMS_SUBQUERY = `{
    __typename
    id
    name
    lastModifiedOn
    ...on BasicItem {
        tipVersion {
            versionNumber
        }
    }
    ...on DesignItem {
        tipVersion {
            versionNumber
        }
        thumbnail {
            signedUrl
        }
    }
    ...on DrawingItem {
        tipVersion {
            versionNumber
        }
        thumbnail {
            signedUrl
        }
    }
    ...on ConfiguredDesignItem {
        tipVersion {
            versionNumber
        }
    }
}`;

export const MFG_QUERY_KEYS = {
  LIST_HUBS: 'listHubs',
  LIST_PROJECTS_BY_HUB: 'listProjectsByHub',
  LIST_FOLDERS_BY_FOLDER: 'listFoldersByFolder',
  LIST_ITEMS_BY_FOLDER: 'listItemsByFolder',
  LIST_FOLDERS_BY_PROJECT: 'listFoldersByProject',
  LIST_ITEMS_BY_PROJECT: 'listItemsByProject',
} as const;

export const FUSION_ITEM_TYPES = {
  BASIC_ITEM: 'BasicItem',
  DESIGN_ITEM: 'DesignItem',
  DRAWING_ITEM: 'DrawingItem',
  CONFIGURED_DESIGN_ITEM: 'ConfiguredDesignItem',
} as const;
